
'format es6';

import $ from 'jquery';
import ns from 'ns';
import gsap from 'greensock';
import Promise from 'Promise';

require('../../views-compiled/pub');

import { factory as sectionFactory } from './Section';

const pubs = require('../../../lang/pubs.json');
const EASING = gsap.Expo;
const TIME_SHOWN = 5000;

function Pub() {
	this.templateName = 'pub.htm';

	this.setAnimation = (tl, rootNode, setInEndTime) => {
		tl.from(rootNode, 0.3, { opacity: 0, ease: EASING.easeIn });
		const animateInFinish = setInEndTime();
		tl.to(rootNode, 0.3, { opacity: 0, ease: EASING.easeOut }, animateInFinish);
		return tl;
	};

	let data;
	this.setData = () => {
		// PAS DE PUB ns.previousPubs = ns.previousPubs || [];
		// PAS DE PUB 
		// PAS DE PUB // Look for a pub we didn't see already.
		// PAS DE PUB // Resets everytime you visit the website (not stored in the localStorage)
		// PAS DE PUB let randIndex = Math.floor(Math.random() * (pubs.length - 1));
		// PAS DE PUB while (ns.previousPubs.indexOf(pubs[randIndex].id) > -1) {
		// PAS DE PUB 	randIndex = Math.floor(Math.random() * (pubs.length - 1));
		// PAS DE PUB }

		// PAS DE PUB ns.previousPubs.push(pubs[randIndex].id);

		let randIndex = 0;
		data = pubs[randIndex];
		data.text = data[`text_${ns.lang}`];
		data.btn_text = data[`btn_text_${ns.lang}`];
		data.link = data[`lien_${ns.lang}`];
		data.img = data[`img_${ns.lang}`];
		data.pubImgPath = `${ns.basePath}/img_db/pub.img`;
	};

	this.init = () => Promise.resolve(data);

	this.activate = () => {
		//dataLayer.push({
		//	'event': 'customEvent',
		//	'eventCategory': 'test cursus',
		//	'eventAction': 'affichage bloc promo',
		//	'eventLabel': data.btn_text,
		//});

		//$('[data-pub-link]').on('click.cursus', (e) => {
		//	dataLayer.push({
		//		'event': 'customEvent',
		//		'eventCategory': 'test cursus',
		//		'eventAction': 'click bloc promo',
		//		'eventLabel': data.btn_text,
		//	});
		//});

		$('.loading').fadeIn();

		const loadTitle = $('[data-load-title]');
		const origTitleText = loadTitle.html();
		loadTitle.css('opacity', 0).html(loadTitle.data('load-title')).css('opacity', 1);

		// Show the pub for a set amount of time, hide it and go 
		// to the next interaction.
		setTimeout(() => {
			$('.loading').fadeOut();
			loadTitle.css('opacity', 0).html(origTitleText).css('opacity', 1);
			this.animateOut().then(() => {
				this.next && this.next();
			});
		}, TIME_SHOWN);
	};

	return this;
}


export function factory(instance) {
	return Pub.call(sectionFactory(instance || {}));
}
